export class DatePickerModel {
    id: string;
    minDate: Date;
    maxDate: Date;
    selectedDate: Date;
    disable: boolean;
    datePickerLabel?: string;
    ariaLabel?: any;
}
